<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaSetarile')}}</h4>
        </div>
        <form class="add-user-form" id='edit-settings' method="POST">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               v-model="input_field.inputValue"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <div class="selections-option" v-if="input_field.inputName === 'county'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label == 1}"> {{$t('placeholder.judet')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label == 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_county"
                                      :options="counties"
                                      label="name"
                                      @input="getCitiesByCounty()">
                            </v-select>
                        </div>
                        <div class="selections-option" v-else-if="input_field.inputName === 'city'" @click="selected_label = 2">
                            <label :class="{select_label_class:selected_label == 2}"> {{$t('placeholder.oras')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label == 2}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_city"
                                      :options="cities"
                                      label="name">
                            </v-select>
                        </div>
                        <div v-else>
                            <input type="text"
                                   class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :name="input_field.inputName"
                                   :data-vv-as="input_field.labelName"
                                   :id="input_field.inputName"
                                   v-model="input_field.inputValue">
                            <label class=""> {{input_field.labelName}} </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                        </div>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-12">
                    <div class="inner-location-group">
                        <div class="save-contact-buttons">
                            <button type="button" @click='saveSettings()'>
                                <i class="fas fa-check"></i>
                                {{$t('placeholder.salveaza')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import SettingsService from '../../api-services/settings.service.js'
import CountiesService from '../../api-services/counties.service.js'
export default {
  name: 'EditSettings',
  data () {
    return {
      settings: {
        phone: null,
        email: null,
        company_name: null,
        cui: null,
        nr_reg_com: null,
        iban: null,
        bank: null,
        county: null,
        city: null,
        address: null
      },
      selected_label: undefined,
      counties: [],
      cities: [],
      select_county: null,
      select_city: null,
      post_data: []
    }
  },
  methods: {
    getSettings () {
      return new Promise((resolve, reject) => {
        SettingsService.get()
          .then((response) => {
            this.settings = response.data.data
            this.$store.dispatch('hideLoading')
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('hideLoading')
            reject(error)
          })
      })
    },
    getCounties () {
      CountiesService.getAll({ per_page: -1 })
        .then((response) => {
          this.counties = response.data.data
          if (this.settings.county) {
            this.select_county = this.counties.find(county => county.id === this.settings.county.id)
            this.getCitiesByCounty()
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCitiesByCounty () {
      let countyId = this.select_county.id
      this.cities = []
      if (countyId && countyId > 0) {
        CountiesService.get(countyId)
          .then((response) => {
            this.cities = response.data.data.cities
            if (this.settings.city) {
              this.select_city = this.cities.find(city => city.id === this.settings.city.id)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    saveSettings () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('edit-settings'))
      if (this.select_county) {
        formData.append('county', this.select_county.id)
      }
      if (this.select_city) {
        formData.append('city', this.select_city.id)
      }
      SettingsService.update(formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.settings = response.data.data
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.setariModificate'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
          this.$store.dispatch('hideLoading')
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.settings) ? this.settings.company_name : '',
            icon: 'fas fa-building',
            validationRules: ''
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.settings) ? this.settings.phone : '',
            icon: 'fas fa-phone',
            validationRules: 'numeric'
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: (this.settings) ? this.settings.cui : '',
            icon: 'fas fa-scroll',
            validationRules: ''
          },
          {
            inputName: 'nr_reg_com',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: (this.settings) ? this.settings.nr_reg_com : '',
            icon: 'fas fa-cash-register',
            validationRules: ''
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            inputValue: (this.settings) ? this.settings.bank : '',
            icon: 'fas fa-piggy-bank',
            validationRules: ''
          }
        ],
        column_2: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: (this.settings) ? this.settings.county : null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: (this.settings) ? this.settings.city : null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: (this.settings) ? this.settings.address : '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.settings) ? this.settings.email : '',
            icon: 'fas fa-envelope',
            validationRules: 'email'
          },
          {
            inputName: 'iban',
            labelName: this.$t('placeholder.iban'),
            inputValue: (this.settings) ? this.settings.iban : '',
            icon: 'fas fa-piggy-bank',
            validationRules: ''
          }
        ]
      }
    }
  },
  async created () {
    await this.getSettings()
    this.getCounties()
  }
}
</script>
